import { render } from "./HeaderBottomMain.vue?vue&type=template&id=299ab9ae"
const script = {}

import "./HeaderBottomMain.vue?vue&type=style&index=0&id=299ab9ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__